<h2 mat-dialog-title style="color:var(--warmOrange);text-align:center;">{{'free_publisher.appointment_features' | translate}}</h2>
<mat-dialog-content>
    <section class="d-flex flex-column text-center my-2">

        <p style="color:white;font-weight:300;font-size:15px;line-height: 18px;">{{'free_publisher.apopintment_features_text' | translate}}</p>
    
        <button mat-button style="background-color: white; color: var(--warmOrange);" class="my-2 w-75 mx-auto" (click)="makeAppointment();">{{'free_publisher.make_apointment' | translate}}</button>

        <!-- <div>
            <p style="color:white; font-size:12px;opacity:0.8;">{{'free_publisher.free_version_info' | translate}}</p>
        </div> -->
    </section>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-button class="orange-button" (click)="closeDialog();">{{data.closeBtnLabel}}</button>
</mat-dialog-actions>